// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d69cca69","455":"7389c0b2"}[chunkId] + ".chunk.js";
};